import { Design } from '../../../types';
import { createCsv, DownloadFileProps } from '../file';
import { getIntentColumns } from './get-intent-columns';

export type CreateIntentCsvConfigProps = {
  serialized: Design;
};

export function createIntentCsvConfig({
  serialized
}: CreateIntentCsvConfigProps): DownloadFileProps {
  const {
    branchName,
    clientName,
    components,
    designName
  } = serialized;

  return {
    fileName: `${clientName}_${designName}_${branchName}_intents.csv`,
    text: () => {
      return createCsv({
        columns: getIntentColumns({ serialized }),
        items: components.intents
      });
    }
  };
}
